import React from "react";
import { FootnoteDisplayEditorContainer } from "./styles";
import Display from "../footnotedisplay/Display";
import { useFootnoteDisplayStore } from "../../../stores/use-footnotedisplay-store";

const FOOTNOTES = [
  {
    macroId: "1",
    content:
      "This is a preview of how the footnote display macro will look like.",
  },
  {
    macroId: "2",
    content:
      "It will be updated with the actual content once the macro is saved.",
  },
];

function FootnoteDisplayEditor() {
  const { data } = useFootnoteDisplayStore((state) => ({
    data: state.data,
  }));

  return (
    <FootnoteDisplayEditorContainer>
      <Display
        title={data.title}
        titleStyle={data.titleStyle}
        footnotes={FOOTNOTES}
      />
    </FootnoteDisplayEditorContainer>
  );
}

export default FootnoteDisplayEditor;
